import ExtensionTester from '../components/extensionTester';
import NoData from '../components/noData';
import StdConfirmBody from '../components/std-confirm-body';
import TrialExpiredDialog from '../components/trial-expired-dialog';
import ShouldInstallExtension from '../components/should-install-extension';
import NewExtensionDialog from '../components/new-extension-dialog';
import $api from '../api';
import { sendMessageToExtensionAsync } from '../utils/extension';

export class RootPage {
    constructor() {
        ExtensionTester();
        NoData();
        StdConfirmBody();
        TrialExpiredDialog(this);
        NewExtensionDialog(this);
        ShouldInstallExtension(this);

        this.dialogShown = ko.observable(false);
        this.dialogHasBackdrop = ko.observable(true);
        this.bodyFaded = ko.observable(false);
        this.dialogStdShown = ko.observable(false);
        this.dialogStdClickHandler = null;
        this.dialogStdTitle = ko.observable();
        this.dialogComponentName = ko.observable();
        this.dialogComponentParams = ko.observable();

        this.topHelpShown = ko.observable(false);

        this.activeTab = ko.observable();
        this.tabsUseHashes = false;

        this.toasts = ko.observableArray();

        this.generalToggler = ko.observableArray();
        this.isToggled = (data) => {
            return ko.computed(() => {
                return this.generalToggler.indexOf(data) !== -1;
            });
        };

        this.generalSubmitter = ko.observableArray();
        this.isSubmitting = (data) => {
            if (!data) data = '__default_page';

            return ko.computed(() => {
                return this.generalSubmitter.indexOf(data) !== -1;
            });
        };

        document.addEventListener('pf_trigger_internal_help', (e) => {
            alert('aa' + e.detail.id);
        });

        this.pageLoaded = ko.observable(true);

        if (window.auth && window.auth.project) {
            const p = window.auth.project;

            sendMessageToExtensionAsync({
                type: 'sync_single_workspace',
                workspace: { uniqueCode: p.UniqueCode, name: p.Name, baseUrl: p.BaseUrl, supportedLanguages: p.SupportedLanguages }
            });
        }

        this.globalExtensionWarning = ko.observable(localStorage.getItem('pf_global_extension_warning'));
        this.globalExtensionWarning.subscribe((res) => {
            if (res) {
                localStorage.setItem('pf_global_extension_warning', '1');
            } else {
                localStorage.removeItem('pf_global_extension_warning');
            }

            this.toggleGlobalExtensionWarning();
        });

        this.toggleGlobalExtensionWarning();

        this.shouldInstallExtension = ko.observable();
        this.shouldInstallExtension.subscribe((val) => {
            if (val) {
                localStorage.setItem('pf_should_install_ext', '1');
            } else {
                localStorage.removeItem('pf_should_install_ext');
            }
        });
    }

    toggleGlobalExtensionWarning() {
        // we do this with jquery, because KO is not always initialized in the same way
        // and we want to avoid crashes

        const $warning = $('.global-extension-warning');

        if (this.globalExtensionWarning()) {
            $warning.show();
        } else {
            $warning.hide();
        }
    }

    onInit() {

    }

    onRender() {

    }

    onAtiveTabChanged(tab) {

    }

    dialogStdClick() {
        this.dialogStdClickHandler && this.dialogStdClickHandler(() => { this.closeDialog(); });
    }

    showStandardDialog(title, componentName, params, okClickFn) {
        this.dialogStdTitle(title);
        this.dialogComponentParams(params);
        this.dialogComponentName(componentName);
        this.dialogStdClickHandler = okClickFn;
        this.dialogStdShown(true);
    }

    showDialog(componentName, params, opts = {}) {
        this.dialogComponentParams(params);
        this.dialogComponentName(componentName);
        this.dialogHasBackdrop(opts.backdrop !== false);
        this.bodyFaded(opts.bodyFaded === true);
        this.dialogShown(true);
    }

    closeDialog() {
        this.bodyFaded(false);
        this.dialogShown(false);
        this.dialogStdShown(false);
        this.dialogComponentName(null);
        this.dialogComponentParams(null);
    }

    confirmStandardDialogAsync(text, checkQuestion, checkAnswer, buttonSet) {
        return new Promise((resolve, reject) => {
            this.showDialog('std-confirm-body', { buttonSet, text, checkQuestion, checkAnswer, success: resolve, cancel: () => { this.closeDialog(); reject(); } });
        });
    }

    confirmStandardDialog(text, { buttonSet = 'delete', checkQuestion, checkAnswer, success, cancel }) {
        this.confirmStandardDialogAsync(text, checkQuestion, checkAnswer, buttonSet)
            .then(() => {
                success && success();
            })
            .catch(() => {
                cancel && cancel();
            });
    }

    /**
     * @deprecated
     * @param {any} key
     */
    getServerSideData(key) {
        if (window.serverSide) {
            return window.serverSide[key];
        }
    }

    setActiveTab(tab) {
        if (this.onActiveTabChanging) {
            if (this.onActiveTabChanging(tab) === false) return;
        }

        if (this.tabsUseHashes) {
            window.location.hash = tab;
        }

        this.activeTab(tab);

        this.onAtiveTabChanged(tab);
    }

    /**
     * 
     * @param {string} text
     * @param {'success'|'error'|'warning'} type
     */
    showToast(text, type = 'success') {
        var toast = new ToastNotif(this, text, type);

        this.toasts.push(toast);

        setTimeout(() => {
            this.toasts.remove(toast);
        }, 4000);
    }

    toggleOn(data) {
        if (this.generalToggler.indexOf(data) === -1) {
            this.generalToggler.push(data);
        }
    }

    toggleOff(data) {
        this.generalToggler.remove(data);
    }

    toggle(data) {
        console.trace();
        if (this.isToggled(data)()) {
            this.toggleOff(data);
        } else {
            this.toggleOn(data);
        }
    }

    startSubmitting(data) {
        if (!data) data = '__default_page';
        this.generalSubmitter.push(data);
    }

    stopSubmitting(data) {
        if (!data) data = '__default_page';
        this.generalSubmitter.remove(data);
    }
}

window._RP = RootPage;

class ToastNotif {
    constructor(pageParent, text, type) {
        this.pageParent = pageParent;
        this.text = text;
        this.type = type;
    }

    close() {
        this.pageParent.toasts.remove(this);
    }
}

export function showDialog(componentName, params, opts = {}) {
    if (window.currentPage) {
        window.currentPage.showDialog(componentName, params, opts);
    } else {
        window.dispatchEvent(new CustomEvent('dialog-request', {
            detail: {
                componentName,
                params,
                opts
            }
        }))
    }
}
window._SD = showDialog;

export function showToast(text, type) {
    window.currentPage.showToast(text, type);
}

export function getServerSideData(key) {
    if (window.serverSide) {
        return window.serverSide[key];
    }
}



window._pfGenerateSampleData = function () {
    $api.projects.generateSampleData(
        { projectCode: auth.project.UniqueCode },
        {},
        () => {
            console.log('OK!');
        }
    )
}